export default __webpack_public_path__ + "static/orbis-7010b5bf6b1b3756672ae05e4fb65675.jpg";